// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2cVPw","overflowing":"ReadFullNote_overflowing__3F75X"};